export function reportGlobalError(errorData) {
    console.log('inside reportGlobalError');
    const url = process.env.REACT_APP_API_URL;
    const apiUrl = `${url}/api/user/master/addUserAppExceptionLog`;
    const respStatus = { SUCCESS: 200 };
    const response = fetch(apiUrl, {
        method: "POST",
        headers: { Origin: window.location.host, "Content-Type": "application/json" },
        body: JSON.stringify(errorData),
    }).then(response => {
        if (!response) {
            console.trace("No response received from the server.");
            return response;
        }
        if (response.status !== respStatus.SUCCESS) {
            console.trace("API response status is not success:", response);
            return response;
        }
        return response;
    }).catch(err => {
        console.trace("API response status is not success:", err);
    });
}